import React from 'react'
import { EditPage } from '@equipedigitalfloripa/ed-cms/components'
import * as categoriaArquivosApi from '../api/categoriaArquivos'
import { useSelector } from 'react-redux'

const EditCategoriaArquivos = ({ edit }) => {
    const translations = useSelector(state => state.translations.translations)
    // const categoriaArquivosTranslations = translations['system-categoriaArquivos']

    const selectedData = [
        {
            name: '_id',
            type: 'hidden',
            title: 'Id'
        },
        {
            name: 'title',
            type: 'text',
            title: "Nome da categoria",
            validation: {
                required: true
            }
        }
    ]
    return (
        <EditPage 
            selectedData={selectedData} 
            addFunction={categoriaArquivosApi.addItem} 
            fetchFunction={categoriaArquivosApi.fetchItem} 
            editFunction={categoriaArquivosApi.editItem} 
            edit={edit} 
            url='categoria_arquivos' 
        />
    )
}

export default EditCategoriaArquivos
